import React from 'react'
import Navbar from './Components/Navbar/Navbar'
import { Route, Routes } from 'react-router-dom'
import Home from './Pages/Home/Home'
import About from './Pages/About/About'
import Contact from './Pages/Contact/Contact'
import Footer from './Components/Footer/Footer'
import Pricing from './Pages/Pricing/Pricing'
import NooraniQaida from './Pages/Courses/NooraniQaida/NooraniQaida'
import OnlineQuranRecitation from './Pages/Courses/OnlineQuranRecitation/OnlineQuranRecitation'
import OnlineQuranMemorization from './Pages/Courses/OnlineQuranMemorization/OnlineQuranMemorization'
import Tafseer from './Pages/Courses/OuranTafseer/Tafseer'
import QuranwithTajweed from './Pages/Courses/QuranWithTajweed/QuranWithTajweed'
import QuranTranslation from './Pages/Courses/QuranTranslation/QuranTranslation'
import OnlineRegistration from './Pages/OnlineRegistration/OnlineRegistration'
import img1 from './Assets/download1.png'
import './App.css'
import ScrollToTop from './ScrollToTop'
import FreeTrailForm from './Pages/3DaysFreeTrail/FreeTrailForm'

const App = () => {
  return (
   <>
    <div className="App">
    <a href='https://wa.me/+923129176057'>
    <img src={img1} className="App-logo" alt="logo"/>

    </a>
   </div>
   <Navbar />
   <ScrollToTop />
   <Routes >
    <Route path='/' element={<Home />} />
    <Route path='/About' element={<About />} />
    <Route path='/Contact' element={<Contact />} />
    <Route path='/Pricing' element={<Pricing />} />
    <Route path='/Noorani-Qaida' element={<NooraniQaida />} />
    <Route path='/OnlineQuranRecitation' element={<OnlineQuranRecitation />} />
    <Route path='/Online-Quran-Memorization' element={<OnlineQuranMemorization />} />
    <Route path='/Tafseer' element={<Tafseer />} />
    <Route path='/Quran-with-Tajweed' element={<QuranwithTajweed />} />
    <Route path='/Quran-Translation' element={<QuranTranslation />} />
    <Route path='/OnlineRegistration' element={<OnlineRegistration />} />
    <Route path='/Registration' element={<FreeTrailForm />} />


   </Routes>
   
   
   
   <Footer />
   
   </>
  )
}

export default App
